export const AuthenticateFormDataConfig: any = [
  {
    key: 'authMode',
    label: 'Authentication Mode',
    defaultValue: '',
    type: 'dropdown',
    size: 6,
    values: [
      { value: 'BASIC_AUTHENTICATION', label: 'Basic Authentication' },
      { value: 'OAUTH_CLIENT_CREDENTIALS_BODY', label: 'Oauth Client Credentials Body' },
      { value: 'OAUTH_CLIENT_CREDENTIALS_BASIC_AUTH', label: 'Oauth Client Credentials Basic Auth' },
      { value: 'OAUTH_CLIENT_CREDENTIALS_FORM', label: 'Oauth Client Credentials Form' },
      { value: 'STATIC_AUTHENTICATION', label: 'Static Authentication' },
      { value: 'INTERNAL_AUTHENTICATION', label: 'Internal Authentication' }
    ],
    rules: {
      required: {
        value: true,
        message: 'Please select a service'
      }
    },
    labelStyleType: 'InputLabel'
  },
  {
    key: 'authUrl',
    label: 'Auth Url',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: false
  },
  {
    key: 'identifier',
    label: 'Identifier',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: false
  },
  {
    key: 'secret',
    label: 'Secret',
    defaultValue: '',
    type: 'password',
    size: 6,
    required: false
  },
  {
    key: 'authTokenHeaderName',
    label: 'Authorization Token Header Name',
    defaultValue: 'Authorizaton',
    type: 'text',
    size: 6,
    required: false
  },
  {
    key: 'authContext',
    label: 'Auth Context',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: false
  },
  {
    key: 'defaultAuth',
    label: 'Is Default',
    defaultValue: 'no',
    type: 'radio',
    size: 12,
    values: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' }
    ]
  },
  {
    key: 'isAdditionalIdentifier',
    label: 'Is Additional Identifier Required',
    defaultValue: 'no',
    type: 'radio',
    size: 12,
    values: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' }
    ]
  }
];
export const ParameterTypeConfig = [
  {
    label: 'Authentication Header',
    value: 'authHeaders'
  },
  {
    label: 'Form Parameter',
    value: 'formParams'
  },
  {
    label: 'Request Header',
    value: 'requestHeaders'
  },
  {
    label: 'Request Body',
    value: 'authBodyParameters'
  }
];

export const PrimaryParamterConfig = [
  {
    label: 'Identifier',
    value: 'identifier'
  },
  {
    label: 'Secret',
    value: 'secret'
  },
  {
    label: 'Auth Url',
    value: 'authUrl'
  }
];

export default AuthenticateFormDataConfig;
